import {
  Button,
  Container,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconLock, IconMail } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../components/AuthProvider';
import { AuthService } from '../../services/auth.service';

// Định nghĩa kiểu dữ liệu cho form login
interface LoginForm {
  email: string;
  password: string;
}

export function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuthContext();

  const form = useForm<LoginForm>({
    initialValues: {
      email: '',
      password: ''
    },
    validate: {
      email: (value: string) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      password: (value: string) => (value.length < 6 ? 'Password must be at least 6 characters' : null)
    }
  });

  const handleLogin = async (values: LoginForm) => {
    try {
      setLoading(true);
      setError('');

      const response = await AuthService.login(values);
      authLogin(response.data.token, response.data.user);
      navigate('/');
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size="xs" py="xl">
      <Paper radius="md" p="xl" withBorder>
        <Title order={2} ta="center" mb="lg">
          supmmo
        </Title>

        <form onSubmit={form.onSubmit(handleLogin)}>
          <Stack>
            {error && (
              <Text c="red" size="sm" ta="center">
                {error}
              </Text>
            )}

            <TextInput
              required
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              {...form.getInputProps('email')}
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              {...form.getInputProps('password')}
            />

            <Button type="submit" loading={loading} fullWidth>
              Sign in
            </Button>

            <Text ta="center" size="sm">
              Don't have an account?{' '}
              <Text component="a" href="/register" c="blue">
                Register
              </Text>
            </Text>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
} 